/** Statuses that partner admins may permanently delete (matches backend). */
const DELETABLE_APPLICATION_STATUSES = new Set([
  "pending",
  "rejected",
  "waitlisted",
]);

export function applicationCanBeDeleted(status) {
  return DELETABLE_APPLICATION_STATUSES.has(status);
}
